// Document Types
export const COUNTRIES = [
  { name: "Afghanistan", code: "afghanistan" },
  { name: "Albania", code: "albania" },
  { name: "Algeria", code: "algeria" },
  { name: "Andorra", code: "andorra" },
  { name: "Angola", code: "angola" },
  { name: "Antigua and Barbuda", code: "antigua and barbuda" },
  { name: "Argentina", code: "argentina" },
  { name: "Armenia", code: "armenia" },
  { name: "Australia", code: "australia" },
  { name: "Austria", code: "austria" },
  { name: "Azerbaijan", code: "azerbaijan" },
  { name: "Bahrain", code: "bahrain" },
  { name: "Bangladesh", code: "bangladesh" },
  { name: "Belgium", code: "belgium" },
  { name: "Brazil", code: "brazil" },
  { name: "Canada", code: "canada" },
  { name: "China", code: "china" },
  { name: "Egypt", code: "egypt" },
  { name: "France", code: "france" },
  { name: "Germany", code: "germany" },
  { name: "India", code: "india" },
  { name: "Indonesia", code: "indonesia" },
  { name: "Iran", code: "iran" },
  { name: "Iraq", code: "iraq" },
  { name: "Ireland", code: "ireland" },
  { name: "Italy", code: "italy" },
  { name: "Japan", code: "japan" },
  { name: "Jordan", code: "jordan" },
  { name: "Kuwait", code: "kuwait" },
  { name: "Lebanon", code: "lebanon" },
  { name: "Malaysia", code: "malaysia" },
  { name: "Mexico", code: "mexico" },
  { name: "Morocco", code: "morocco" },
  { name: "Netherlands", code: "netherlands" },
  { name: "New Zealand", code: "new zealand" },
  { name: "Nigeria", code: "nigeria" },
  { name: "Norway", code: "norway" },
  { name: "Oman", code: "oman" },
  { name: "Pakistan", code: "pakistan" },
  { name: "Palestine", code: "palestine" },
  { name: "Philippines", code: "philippines" },
  { name: "Poland", code: "poland" },
  { name: "Portugal", code: "portugal" },
  { name: "Qatar", code: "qatar" },
  { name: "Russia", code: "russia" },
  { name: "Saudi Arabia", code: "saudi arabia" },
  { name: "Singapore", code: "singapore" },
  { name: "South Africa", code: "south africa" },
  { name: "South Korea", code: "south korea" },
  { name: "Spain", code: "spain" },
  { name: "Sweden", code: "sweden" },
  { name: "Switzerland", code: "switzerland" },
  { name: "Syria", code: "syria" },
  { name: "Thailand", code: "thailand" },
  { name: "Turkey", code: "turkey" },
  { name: "Ukraine", code: "ukraine" },
  { name: "United Arab Emirates", code: "united arab emirates" },
  { name: "United Kingdom", code: "united kingdom" },
  { name: "United States", code: "united states" },
  { name: "Vietnam", code: "vietnam" },
  { name: "Yemen", code: "yemen" },
];

export const GULF_COUNTRIES = [
  { name: "Bahrain",              code: "bahrain" },
  { name: "Kuwait",               code: "kuwait" },
  { name: "Oman",                 code: "oman" },
  { name: "Qatar",                code: "qatar" },
  { name: "Saudi Arabia",         code: "saudi arabia" },
  { name: "United Arab Emirates", code: "united arab emirates" },
];

export const HEAR_ABOUT_US_OPTIONS = [
  { name: "Google Search", code: "google_search" },
  { name: "Facebook", code: "facebook" },
  { name: "Instagram", code: "instagram" },
  { name: "LinkedIn", code: "linkedin" },
  { name: "TikTok", code: "tiktok" },
  { name: "Friend or Family", code: "friend_family" },
  { name: "Educational Agent", code: "educational_agent" },
  { name: "School / University", code: "school_university" },
  { name: "Event / Exhibition", code: "event_exhibition" },
  { name: "WhatsApp", code: "whatsapp" },
  { name: "Other", code: "other" },
];

export const NATIONALITIES = [
  { name: "Afghan", label: "Afghan" },
  { name: "Albanian", label: "Albanian" },
  { name: "Algerian", label: "Algerian" },
  { name: "Andorran", label: "Andorran" },
  { name: "Angolan", label: "Angolan" },
  { name: "Antiguan and Barbudan", label: "Antiguan and Barbudan" },
  { name: "Argentine", label: "Argentine" },
  { name: "Armenian", label: "Armenian" },
  { name: "Australian", label: "Australian" },
  { name: "Austrian", label: "Austrian" },
  { name: "Azerbaijani", label: "Azerbaijani" },
  { name: "Bahamian", label: "Bahamian" },
  { name: "Bahraini", label: "Bahraini" },
  { name: "Bangladeshi", label: "Bangladeshi" },
  { name: "Barbadian", label: "Barbadian" },
  { name: "Belarusian", label: "Belarusian" },
  { name: "Belgian", label: "Belgian" },
  { name: "Belizean", label: "Belizean" },
  { name: "Beninese", label: "Beninese" },
  { name: "Bhutanese", label: "Bhutanese" },
  { name: "Bolivian", label: "Bolivian" },
  { name: "Bosnian and Herzegovinian", label: "Bosnian and Herzegovinian" },
  { name: "Botswanan", label: "Botswanan" },
  { name: "Brazilian", label: "Brazilian" },
  { name: "Bruneian", label: "Bruneian" },
  { name: "Bulgarian", label: "Bulgarian" },
  { name: "Burkinabe", label: "Burkinabe" },
  { name: "Burundian", label: "Burundian" },
  { name: "Cambodian", label: "Cambodian" },
  { name: "Cameroonian", label: "Cameroonian" },
  { name: "Canadian", label: "Canadian" },
  { name: "Cape Verdean", label: "Cape Verdean" },
  { name: "Central African", label: "Central African" },
  { name: "Chadian", label: "Chadian" },
  { name: "Chilean", label: "Chilean" },
  { name: "Chinese", label: "Chinese" },
  { name: "Colombian", label: "Colombian" },
  { name: "Comoran", label: "Comoran" },
  { name: "Costa Rican", label: "Costa Rican" },
  { name: "Croatian", label: "Croatian" },
  { name: "Cuban", label: "Cuban" },
  { name: "Cypriot", label: "Cypriot" },
  { name: "Czech", label: "Czech" },
  { name: "Danish", label: "Danish" },
  { name: "Djiboutian", label: "Djiboutian" },
  { name: "Dominican", label: "Dominican" },
  { name: "Ecuadorian", label: "Ecuadorian" },
  { name: "Egyptian", label: "Egyptian" },
  { name: "Salvadoran", label: "Salvadoran" },
  { name: "Equatorial Guinean", label: "Equatorial Guinean" },
  { name: "Eritrean", label: "Eritrean" },
  { name: "Estonian", label: "Estonian" },
  { name: "Eswatini", label: "Eswatini" },
  { name: "Ethiopian", label: "Ethiopian" },
  { name: "Fijian", label: "Fijian" },
  { name: "Finnish", label: "Finnish" },
  { name: "French", label: "French" },
  { name: "Gabonese", label: "Gabonese" },
  { name: "Gambian", label: "Gambian" },
  { name: "Georgian", label: "Georgian" },
  { name: "German", label: "German" },
  { name: "Ghanaian", label: "Ghanaian" },
  { name: "Greek", label: "Greek" },
  { name: "Grenadian", label: "Grenadian" },
  { name: "Guatemalan", label: "Guatemalan" },
  { name: "Guinean", label: "Guinean" },
  { name: "Guinea-Bissauan", label: "Guinea-Bissauan" },
  { name: "Guyanese", label: "Guyanese" },
  { name: "Haitian", label: "Haitian" },
  { name: "Honduran", label: "Honduran" },
  { name: "Hungarian", label: "Hungarian" },
  { name: "Icelandic", label: "Icelandic" },
  { name: "Indian", label: "Indian" },
  { name: "Indonesian", label: "Indonesian" },
  { name: "Iranian", label: "Iranian" },
  { name: "Iraqi", label: "Iraqi" },
  { name: "Irish", label: "Irish" },
  { name: "Italian", label: "Italian" },
  { name: "Jamaican", label: "Jamaican" },
  { name: "Japanese", label: "Japanese" },
  { name: "Jordanian", label: "Jordanian" },
  { name: "Kazakhstani", label: "Kazakhstani" },
  { name: "Kenyan", label: "Kenyan" },
  { name: "Kiribati", label: "Kiribati" },
  { name: "Kuwaiti", label: "Kuwaiti" },
  { name: "Kyrgyzstani", label: "Kyrgyzstani" },
  { name: "Lao", label: "Lao" },
  { name: "Latvian", label: "Latvian" },
  { name: "Lebanese", label: "Lebanese" },
  { name: "Basotho", label: "Basotho" },
  { name: "Liberian", label: "Liberian" },
  { name: "Libyan", label: "Libyan" },
  { name: "Liechtensteinian", label: "Liechtensteinian" },
  { name: "Lithuanian", label: "Lithuanian" },
  { name: "Luxembourgish", label: "Luxembourgish" },
  { name: "Malagasy", label: "Malagasy" },
  { name: "Malawian", label: "Malawian" },
  { name: "Malaysian", label: "Malaysian" },
  { name: "Maldivian", label: "Maldivian" },
  { name: "Malian", label: "Malian" },
  { name: "Maltese", label: "Maltese" },
  { name: "Marshallese", label: "Marshallese" },
  { name: "Mauritanian", label: "Mauritanian" },
  { name: "Mauritian", label: "Mauritian" },
  { name: "Mexican", label: "Mexican" },
  { name: "Micronesian", label: "Micronesian" },
  { name: "Moldovan", label: "Moldovan" },
  { name: "Monacan", label: "Monacan" },
  { name: "Mongolian", label: "Mongolian" },
  { name: "Montenegrin", label: "Montenegrin" },
  { name: "Moroccan", label: "Moroccan" },
  { name: "Mozambican", label: "Mozambican" },
  { name: "Myanmarian", label: "Myanmarian" },
  { name: "Namibian", label: "Namibian" },
  { name: "Nauruan", label: "Nauruan" },
  { name: "Nepalese", label: "Nepalese" },
  { name: "Dutch", label: "Dutch" },
  { name: "New Zealander", label: "New Zealander" },
  { name: "Nicaraguan", label: "Nicaraguan" },
  { name: "Nigerien", label: "Nigerien" },
  { name: "Nigerian", label: "Nigerian" },
  { name: "North Korean", label: "North Korean" },
  { name: "Macedonian", label: "Macedonian" },
  { name: "Norwegian", label: "Norwegian" },
  { name: "Omani", label: "Omani" },
  { name: "Pakistani", label: "Pakistani" },
  { name: "Palauan", label: "Palauan" },
  { name: "Palestinian", label: "Palestinian" },
  { name: "Panamanian", label: "Panamanian" },
  { name: "Papua New Guinean", label: "Papua New Guinean" },
  { name: "Paraguayan", label: "Paraguayan" },
  { name: "Peruvian", label: "Peruvian" },
  { name: "Filipino", label: "Filipino" },
  { name: "Polish", label: "Polish" },
  { name: "Portuguese", label: "Portuguese" },
  { name: "Qatari", label: "Qatari" },
  { name: "Romanian", label: "Romanian" },
  { name: "Russian", label: "Russian" },
  { name: "Rwandan", label: "Rwandan" },
  { name: "Saudi", label: "Saudi" },
  { name: "Senegalese", label: "Senegalese" },
  { name: "Serbian", label: "Serbian" },
  { name: "Singaporean", label: "Singaporean" },
  { name: "Slovak", label: "Slovak" },
  { name: "Slovenian", label: "Slovenian" },
  { name: "Somali", label: "Somali" },
  { name: "South African", label: "South African" },
  { name: "South Korean", label: "South Korean" },
  { name: "Spanish", label: "Spanish" },
  { name: "Sri Lankan", label: "Sri Lankan" },
  { name: "Sudanese", label: "Sudanese" },
  { name: "Surinamese", label: "Surinamese" },
  { name: "Swedish", label: "Swedish" },
  { name: "Swiss", label: "Swiss" },
  { name: "Syrian", label: "Syrian" },
  { name: "Taiwanese", label: "Taiwanese" },
  { name: "Tajikistani", label: "Tajikistani" },
  { name: "Tanzanian", label: "Tanzanian" },
  { name: "Thai", label: "Thai" },
  { name: "Togolese", label: "Togolese" },
  { name: "Trinidadian and Tobagonian", label: "Trinidadian and Tobagonian" },
  { name: "Tunisian", label: "Tunisian" },
  { name: "Turkish", label: "Turkish" },
  { name: "Turkmen", label: "Turkmen" },
  { name: "Ugandan", label: "Ugandan" },
  { name: "Ukrainian", label: "Ukrainian" },
  { name: "Emirati", label: "Emirati" },
  { name: "British", label: "British" },
  { name: "American", label: "American" },
  { name: "Uruguayan", label: "Uruguayan" },
  { name: "Uzbekistani", label: "Uzbekistani" },
  { name: "Vanuatuan", label: "Vanuatuan" },
  { name: "Vatican", label: "Vatican" },
  { name: "Venezuelan", label: "Venezuelan" },
  { name: "Vietnamese", label: "Vietnamese" },
  { name: "Yemeni", label: "Yemeni" },
  { name: "Zambian", label: "Zambian" },
  { name: "Zimbabwean", label: "Zimbabwean" }
];